var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"preview-wrap"},[(_vm.isPreview)?_c('c-preview',{attrs:{"id":_vm.documentId,"subfix":_vm.subfix,"file":_vm.file}}):_c('p',[_vm._v("\n    "+_vm._s(_vm.errText)+"\n  ")])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-380fab19","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/preview/index.vue
// module id = null
// module chunks = 